import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
import { forwardRef, memo } from "react";
export const TableRow = /*#__PURE__*/ memo(/*#__PURE__*/ forwardRef((param, ref)=>{
    let { className, ...props } = param;
    return /*#__PURE__*/ _jsx("div", {
        tabIndex: 0,
        className: classNames("tableRow flex items-center text-sm text-grey-10", className),
        ref: ref,
        ...props
    });
}));
TableRow.displayName = "TableRow";
